import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=bc4bbba8&"
import script from "./AnimatedButton.vue?vue&type=script&lang=js&"
export * from "./AnimatedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports